<div id="container">
    <div id="icon"><mat-icon [svgIcon]="icon"></mat-icon></div>
    <div id="text">{{ text }}</div>
</div>
